import type * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const sections = {
  personalInformation: {
    phraseKey: 'CRATE_VITA_TEMPLATES_PERSONAL_TITLE',
    qaAttribute: 'preview-section-personal-info',
  },
  career: {
    phraseKey: 'CRATE_VITA_TEMPLATES_PROFESSIONAL_TITLE',
    qaAttribute: 'preview-section-career',
  },
  education: {
    phraseKey: 'CRATE_VITA_TEMPLATES_EDUCATION_TITLE',
    qaAttribute: 'preview-section-education',
  },
  skills: {
    phraseKey: 'CRATE_VITA_TEMPLATES_SKILLS_TITLE',
    qaAttribute: 'preview-section-skills',
  },
  aboutMe: {
    phraseKey: 'CRATE_VITA_TEMPLATES_ABOUT_ME_TITLE',
    qaAttribute: 'preview-section-about-me',
  },
};

// we need this container because the header can be inline and we want the margins to collapse
export const Container = styled.div<{ $margin?: string }>`
  margin: ${({ $margin }) => $margin ?? '25px 0 10px 0'};
`;

export const SectionHeaderStyled = styled.div`
  border-bottom: 1px solid rgba(20, 71, 108, 0.2);
  margin: 0;
  padding-bottom: 5px;
  color: #000000;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
`;

export type SectionType = keyof typeof sections;

type SectionProps = {
  name: SectionType;
  HeaderStyle?: (
    props: React.PropsWithChildren<{ as: string }>
  ) => React.ReactElement;
  $margin?: string;
};

export const TemplateSection: React.FC<SectionProps> = ({
  name,
  HeaderStyle,
  $margin,
}) => {
  const Header = HeaderStyle ?? SectionHeaderStyled;

  return (
    <Container data-qa={sections[name].qaAttribute} $margin={$margin}>
      <Header as="h2">
        <FormattedMessage id={sections[name].phraseKey} />
      </Header>
    </Container>
  );
};
